import { Button, Grid, SingleSelect } from "designSystem/index";
import React from "react";
import { sortedByGroupItems as originalItems } from "designSystemLegacy/data";
import { cloneDeep } from "lodash";

export default () => {
	const items = cloneDeep(originalItems);

	const selectActions = [
		<Button onClick={() => console.log("Example action A")} res="Example action A" />,
		<Button onClick={() => console.log("Example action B")} res="Example action B" />,
	];

	return (
		<Grid
			container
			direction="column"
			spacing={4}
		>
			<Grid item>
				<SingleSelect
					options={items}
					selectActions={selectActions}
					value={items[0]}
				/>
			</Grid>
		</Grid>
	);
};
